<template>
  <AppPopover
    id="members-info-popover"
    ref="AppPopover"
    placement="top"
    hide-close
    :hide-from-action="hideMemberPopover"
    data-tipclass="member-popover-tooltip"
  >
    <div class="d-flex align-items-center my-15">
      <template v-if="showUserStatus">
        <div
          class="user-status user-status--speck mr-10"
          :class="{ 'is-online': membership.is_online }"
        >
          <AppAvatar
            :avatar="membership.user.avatar_url?.normal || membership.user.avatar_url"
            size="medium"
          />
        </div>
      </template>
      <template v-else>
        <div class="mr-10">
          <AppAvatar
            :avatar="membership.user.avatar_url?.normal || membership.user.avatar_url"
            size="medium"
          />
        </div>
      </template>
      <div class="info-popover-header">
        <div class="popover-type">Member {{ columnType }}</div>
        <div class="member-name">{{ membership.user.name }}</div>
      </div>
    </div>

    <MemberProfileData
      :profile-fields="profileFields"
      :member-data="membership"
      :column-type="columnType"
      :showing-all="showAllFields"
      expanded
    />

    <div class="d-flex mt-30 justify-content-between mb-20">
      <template v-if="showAllFieldsToggle">
        <div
          v-if="!anyFieldsHidden"
          v-tooltip
          title="All fields enabled"
        >
          <AppOnOffToggle
            value
            disabled
          >
            Show all fields
          </AppOnOffToggle>
        </div>
        <AppOnOffToggle
          v-else
          :value="showAllFields"
          @input="toggleFields"
        >
          Show all fields
        </AppOnOffToggle>
      </template>
      <a
        class="text-lighter strong"
        :href="memberProfileLink"
        target="_blank"
      >
        View profile
      </a>
    </div>
    <template
      v-if="defaultSlotPresent"
      #trigger
    >
      <slot />
    </template>
  </AppPopover>
</template>

<script>
import { isBoolean } from 'lodash-es';
import AppPopover from '~/components/AppPopover.vue';
import MemberProfileData from './MemberProfileData.vue';
import { PopoverAvatarUserCardResource } from '~/resources';

export default {
  name: 'PopoverProfileData',
  components: {
    AppPopover,
    MemberProfileData,
  },
  props: {
    organizationId: {
      type: [String, Number],
      required: true,
    },
    hideMemberPopover: {
      type: Boolean,
      default: false,
    },
    membership: {
      type: Object,
      required: true,
    },
    profileFields: {
      type: Object,
      required: true,
    },
    columnType: {
      type: String,
      default: 'info',
    },
    anyFieldsHidden: {
      type: Boolean,
      default: false,
    },
    showAllFieldsToggle: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showAllFields: true,
    };
  },
  computed: {
    defaultSlotPresent() {
      return this.$slots && !!this.$slots.default;
    },
    memberProfileLink() {
      return PopoverAvatarUserCardResource.memberProfileLink({
        userId: this.membership.user.id,
        organizationId: this.organizationId,
        tab: this.columnType,
      });
    },
    showUserStatus() {
      return isBoolean(this.membership.is_online);
    },
  },
  watch: {
    anyFieldsHidden(newVal) {
      this.showAllFields = !newVal;
    },
  },
  methods: {
    toggleFields() {
      this.showAllFields = !this.showAllFields;

      // Forces the popover to reorient itself since its size will change
      window.dispatchEvent(new Event('resize'));
    },
  },
};
</script>
